<nav
  id="navtabs"
  class="card md-tabs-1 md-card-tabs-1 navbar navbar-light bg-faded"
>
  <ul class="text-center">
    <li class="nav-item">
      <a
        class="nav-link"
        [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="['/profile', profile.username]"
      >
        <i class="icofont icofont-bag-alt"></i>
        <span>Created Discussions</span>
      </a>
    </li>
    <li class="nav-item">
      <a
        class="nav-link"
        [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="['/profile', profile.username, 'voted']"
      >
        <i class="icofont icofont-expand-alt"></i>
        <span>Voted Discussions</span>
      </a>
    </li>
    <li *ngIf="ownsProfile" class="nav-item">
      <a
        class="nav-link"
        [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="['/profile', profile.username, 'bookmarked']"
      >
        <i class="icofont icofont-book-mark"></i>
        <span>Bookmarked Discussions</span>
      </a>
    </li>
  </ul>
</nav>
